// Vitesse moyenne de lecture en français : ~250 mots/minute
const WORDS_PER_MINUTE = 250;

export function estimateReadingTime(text) {
  if (!text) return 0;
  const words = text.trim().split(/\s+/).length;
  return Math.ceil(words / WORDS_PER_MINUTE);
}

export function estimateBookReadingTime(chapters) {
  if (!chapters || chapters.length === 0) return 0;
  return chapters.reduce((total, chapter) => {
    return total + estimateReadingTime(chapter.content);
  }, 0);
}

export function formatReadingTime(minutes) {
  if (minutes < 1) return '< 1 min';
  if (minutes < 60) return minutes + ' min';
  const hours = Math.floor(minutes / 60);
  const remaining = minutes % 60;
  if (remaining === 0) return hours + 'h';
  return hours + 'h' + remaining + 'min';
}